import script from "./ExpenseTemplateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpenseTemplateModal.vue?vue&type=script&setup=true&lang=js"

import "./ExpenseTemplateModal.vue?vue&type=style&index=0&id=7b1af48d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b1af48d"]])

export default __exports__